export enum DeviceType {
    VibeAir = 'Vibe Air',
    VibeGo = 'Vibe Go',
    VibeComplete = 'Vibe Complete',
}
